var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#currentColor",
    d: "M11.747 11.91a2.25 2.25 0 1 1-4.366-.765L4.07 9.017a2.25 2.25 0 1 1 0-3.213L7.38 3.68a2.256 2.256 0 1 1 .542.84L4.611 6.649a2.25 2.25 0 0 1 0 1.531l3.312 2.128a2.25 2.25 0 0 1 3.824 1.603"
  })));
};
export default SvgShare;